export default __webpack_public_path__ + "static/media/success.8a76f363.svg";